<template>

    <div class="kalem">
    <resultDialog ref="showMessage"></resultDialog>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

        <v-card flat>

            <v-layout row wrap>

                <v-flex xs12 md12 sm12>
                    <v-layout row wrap>

                        <v-flex pa-2 xs12 sm12>
                            <v-layout row wrap>
                                <v-flex pa-1 xs2 sm2>
                                    <v-btn outline color="info" @click="voucherekran(val.Rez.pNR_No,val.Rez)" block>Voucher</v-btn>
                                </v-flex>
                                <v-flex pa-1 xs2 sm2>
                                    <v-btn outline color="info" @click="otelrezervasyonfisi(val.Rez.pNR_No)" block> {{ $t('Hotel-Reservation-Bill') }} </v-btn>
                                </v-flex>

                                <v-flex pa-1 xs2 sm2>
                                    <v-btn color="info" outline @click="FaturaGoster(val.Rez.pNR_No)" block> {{ $t('Show-Invoice') }}
                                    </v-btn>
                                </v-flex>

                                   <v-flex pa-1 xs2 sm2>
                                    <v-btn color="info" outline @click="kotasyonFormu(val.Rez.pNR_No)" block>{{ $t('Quotation-Form') }}
                                    </v-btn>
                                </v-flex>
                            </v-layout>

                        </v-flex>


                        <!-- <v-flex pa-2 xs12 sm12>
                            <v-layout justify-end row>
                               <v-btn @click="voucheryazdir()" color="info" outline>
                                    <v-icon small>print</v-icon> {{ $t('Print') }}
                                </v-btn>

                                <v-btn @click="denemeyazdir('printJS-form')" color="info" outline>
                                    <v-icon small>print</v-icon> {{ $t('Print') }}
                                </v-btn>
                            </v-layout>
                        </v-flex> -->


                        <v-flex xs12 pa-2 sm12>


                            <div id="printJS-form">
                                <table v-for="item in voucheritems.Sayfalar" :key="item.id" width="100%">
                                    <thead class="print">
                                        <tr>
                                            <td bgcolor="grey" colspan=8 align=center
                                                style="padding-top:20px;padding-bottom:20px;">
                                                <span class=" white--text title"> OTEL VOUCHER</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="vertical-align:top; padding-top:10px;padding-bottom:10px;">
                                                {{ $t('Company-Name-v2') }}
                                            </td>
                                            <td>
                                                {{item.Satici.Isim}}
                                            </td>
                                            <td>
                                                {{$t('Telephone')}}
                                            </td>
                                            <td>
                                                {{item.Satici.Tel1}} / {{item.Satici.Tel2}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                {{ $t('Company-Address') }}
                                            </td>
                                            <td>
                                                {{item.Satici.Adres}} &nbsp; {{item.Satici.Yer}} &nbsp;
                                                {{item.Satici.Ulke}}
                                            </td>
                                            <td>
                                                {{$t('Email_label')}}
                                            </td>
                                            <td>
                                                -
                                            </td>
                                        </tr>


                                        <tr>
                                            <td colspan=8>
                                                <table width="100%">
                                                    <tr bgcolor="grey" colspan=8 align=center
                                                        style="padding-top:20px;padding-bottom:20px;">
                                                        <td style="width:5%">
                                                            <span class=" white--text subheading"> {{ $t('Room-Row') }} </span>
                                                        </td>
                                                        <td style="width:10%">
                                                            <span class=" white--text subheading"> Pnr No</span>
                                                        </td>
                                                        <td style="width:10%">
                                                            <span class=" white--text subheading"> {{$t('Person-Type')}} </span>
                                                        </td>
                                                        <td style="width:20%">
                                                            <span class=" white--text subheading"> {{ $t('Name') }} </span>
                                                        </td>
                                                        <td style="width:15%">
                                                            <span class=" white--text subheading"> {{ $t('Check-in-Date') }} </span>
                                                        </td>
                                                        <td style="width:15%">
                                                            <span class=" white--text subheading"> {{ $t('Check-out-Date') }} </span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class=" white--text subheading"> {{ $t('night') }} </span>
                                                        </td>
                                                        <td style="width:20%">
                                                            <span class=" white--text subheading"> {{$t('Room-Type')}} </span>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan=8>
                                                <table v-for="itemoda in item.Odalar" :key="itemoda.Sira" width="100%">
                                                    <tr v-for="itemkisi in itemoda.Kisiler" :key="itemkisi.adsoyad"
                                                        colspan=8 align=center
                                                        style="padding-top:20px;padding-bottom:20px;">
                                                        <td style="width:5%">
                                                            <span class="  subheading"> {{itemoda.Sira}}</span>
                                                        </td>
                                                        <td style="width:10%">
                                                            <span class="  subheading"> {{val.Rez.pNR_No}}</span>
                                                        </td>
                                                        <td style="width:10%">
                                                            <span class="  subheading">
                                                                {{KisiTipToStr(itemkisi.kisiTip)}}
                                                            </span>
                                                        </td>
                                                        <td align="left" style="align:left;width:20%">
                                                            <span class="  subheading"> {{itemkisi.adSoyad}}</span>
                                                        </td>
                                                        <td style="width:15%">
                                                            <span class="  subheading"> {{itemoda.Kalem.donem1}}</span>
                                                        </td>
                                                        <td style="width:15%">
                                                            <span class="  subheading"> {{itemoda.Kalem.donem2}}</span>
                                                        </td>
                                                        <td style="width:5%">
                                                            <span class="  subheading">
                                                                {{gunhesapla(itemoda.Kalem)}}</span>
                                                        </td>
                                                        <td style="width:20%">
                                                            <span class="  subheading">
                                                                {{itemoda.Kalem.kalemOtel.pansiyon}}{{itemoda.Kalem.kalemOtel.odaTipi.isim}}</span>
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td colspan="8">
                                                            <v-divider></v-divider>
                                                        </td>
                                                    </tr>


                                                </table>

                                            </td>
                                        </tr>






                                        <tr>
                                            <td colspan=4>
                                                <table align="left" width="100%">
                                                    <tr align=left style="padding-top:20px;padding-bottom:20px;">
                                                        <td colspan=2>
                                                            <span class="  subheading"> {{ $t('Total-Passengers') }} : 10</span>
                                                        </td>


                                                    </tr>
                                                    <tr align=left style="padding-top:20px;padding-bottom:20px;">

                                                        <td colspan=2>
                                                            <span class="  subheading"> {{ $t('Total-Rooms') }} : 5</span>
                                                        </td>

                                                    </tr>

                                                </table>
                                            </td>
                                        </tr>

                                        <tr style="height:100%;padding-top:50px;">
                                            <td bgcolor="grey" colspan=4 align=center
                                                style="padding-top:10px;padding-bottom:10px;">
                                                <span class=" white--text title"> {{ $t('CANCELLATION-EXIT-PROCEDURE') }}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan=4 width="100%"
                                                style="vertical-align:top; padding-top:10px;padding-bottom:10px;">
                                                BU NEDENLERDEN DOLAYI DEĞİŞKENLİK GÖSTEREN OTEL / ÜLKE UYGULAMALARINDAN
                                                {{voucheritems.SirketBilgileri.SirketIsmi}} SORUMLU
                                                TUTULAMAZ.
                                            </td>

                                        </tr>

                                        <tr style="height:100%;">
                                            <td bgcolor="grey" colspan=4 align=center
                                                style="padding-top:10px;padding-bottom:10px;">
                                                <span class=" white--text title"> {{ $t('TERMS-AND-CONDITIONS') }}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan=4 width="100%"
                                                style="vertical-align:top; padding-top:10px;padding-bottom:10px;"><span
                                                    style="text-align: center;">
                                                    Lütfen rezervasyon yaptırırken geç giriş talebinizi bildiriniz. Bazı
                                                    oteller, oda fiyatına
                                                    yansımayan ve yolcudan direkt tahsil edilen resort fee veya city tax
                                                    adı
                                                    altında extra
                                                    ücretler talep edebilirler.
                                                    {{voucheritems.SirketBilgileri.SirketIsmi}} sisteme yansımayan bu
                                                    gibi
                                                    durumlardan
                                                    sorumlu
                                                    tutulamaz.
                                                    ↵ODA TİPLERİ: Oda tipi odanın ve otelin müsaitliğine, otelin oda
                                                    tipi
                                                    ayrımlarına ve otelin
                                                    bulunduğu ülkeye göre değişiklik göstermektedir. Ekstra talepleriniz
                                                    (non-smoking, smoking,
                                                    upper floor vb.) rezervasyon anında garanti edilmemektedir. Otelin
                                                    müsaitliğine göre, giriş
                                                    anında kesinleşecektir. Otellerin yıldız kategorileri belirlenirken
                                                    baz
                                                    alınan kriterler
                                                    ülkeden ülkeye değişmektedir. Otellerin yıldız kategorilerinde ve
                                                    otel
                                                    bilgilerinde
                                                    oluşabilecek farklılıklardan
                                                    {{voucheritems.SirketBilgileri.SirketIsmi}} sorumlu tutulamaz.
                                                    ↵ÖDEME: Döviz kurları piyasadaki degişiklikler baz alınarak
                                                    {{voucheritems.SirketBilgileri.SirketIsmi}}
                                                    tarafından
                                                    belirlenmektedir ve günlük olarak değişmektedir.
                                                    ↵İPTAL VE DEĞİŞİKLİK: Direkt otel ile bağlantı kurularak yapılan
                                                    değişiklik
                                                    ve iptal
                                                    talepleri geçerli sayılmamaktadır. Bu tür bilgilendirmeler e-mail,
                                                    faks
                                                    ya
                                                    da telefon yolu
                                                    ile {{voucheritems.SirketBilgileri.SirketIsmi}} 'e bildirilmelidir.
                                                    {{voucheritems.SirketBilgileri.SirketIsmi}} ile bağlantı kurulmadan
                                                    yapılan
                                                    tüm değişiklik ve
                                                    iptallerde sorumluluk misafire aittir. Rezervasyonun yapıldığı tarih
                                                    ve
                                                    ilgili otelde oluşan
                                                    fuar, kongre organizasyonları ve yılbaşı ile bayram dönemleri gibi
                                                    "special
                                                    event"
                                                    durumlarında yapılan değişiklik ve iptallerde % 100 cezai şart
                                                    uygulanabilir
                                                    ve ekstra
                                                    ödemeler oluşabilir.
                                                    ↵BOOK OUT: Otellerin fazla oda satışı nedeni ile oluşan “book out”
                                                    problemlerinde {{voucheritems.SirketBilgileri.SirketIsmi}}
                                                    müşteriye alternatif sunmakla yükümlüdür ancak bu durumdan sorumlu
                                                    tutulamaz.
                                                    ↵EK BİLGİLER: {{voucheritems.SirketBilgileri.SirketIsmi}} kendi
                                                    kontrolü dışında oluşan durumlardan
                                                    (--------sel, deprem,
                                                    savaş, isyan, terörist saldırı, hükümet değişikliği, kötü hava
                                                    koşulları,
                                                    otellerde oluşan
                                                    büyük tadilatlardan) sorumlu tutulamaz. İklim farklılıkları, enerji
                                                    tasarrufu uygulamaları,
                                                    ısıtma ve soğutma sistemlerinin işletilmesi ve bu sistemlerin
                                                    kullanılması
                                                    ülkenin veya
                                                    rezervasyonun yapıldığı bölgenin uygulamasına göre değişkenlik
                                                    göstermektedir. Ornegin
                                                    İtalya yalnızca 15.Kasım & 15.Mart tarihleri arasında ısıtma
                                                    sistemlerini
                                                    açık tutmaktadır.
                                                    Bu nedenlerden dolayı değişkenlik gösteren otel / ülke
                                                    uygulamalarından
                                                    {{voucheritems.SirketBilgileri.SirketIsmi}} sorumlu
                                                    tutulamaz. {{voucheritems.SirketBilgileri.SirketIsmi}} yukarıda
                                                    beyan ettiği koşul ve şartları
                                                    değiştirme
                                                    hakkını saklı tutar.
                                                </span> </td>

                                        </tr>
                                        <tr>
                                        </tr>

                                        <tr pt-5 style="margin-top:100px;">

                                            <td colspan=4>
                                                <table width="100%">
                                                    <tr>
                                                        <td>
                                                            {{voucheritems.SirketBilgileri.SirketIsmi}}
                                                        </td>
                                                        <td>
                                                            {{$t('Person-Offering-Booking')}}
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{voucheritems.SirketBilgileri.SirketAdres1}}
                                                        </td>
                                                        <td>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{voucheritems.SirketBilgileri.SirketAdres2}}
                                                        </td>
                                                        <td>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{voucheritems.SirketBilgileri.SirketTelefon}}
                                                        </td>
                                                        <td>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            {{voucheritems.SirketBilgileri.SirketFaks}}
                                                        </td>
                                                        <td>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>
                                                            mail
                                                        </td>
                                                        <td>
                                                        </td>



                                                    </tr>

                                                </table>
                                            <td>





                                            </td>

                                        </tr>

                                    </thead>

                                </table>
                                <div class="pagebreak"> </div>

                            </div>

                        </v-flex>


                    </v-layout>

                </v-flex>



            </v-layout>
        </v-card>
    </div>
</template>

<script>
    import rez from "../rezervasyon";
    import printJS from 'print-js'
    import kur from "@/components/app/coper/comp/kur.vue";
    import genelarama from "@/components/app/coper/comp/genelarama.vue";
    import genelaramakod from "@/components/app/coper/comp/genelaramakod.vue";
    import tarihcomp from '../../customcomp/tarihim'
    import parainput from '../../customcomp/parainput'
    import yuzdeinput from '../../customcomp/yuzdeinput'
    import tool from "../tools";
    import geneltipara from "@/components/app/coper/comp/geneltipara.vue";
    import resultDialog from "@/components/app/customcomp/resultDialog.vue"
    import snackbarcomp from "@/components/app/customcomp/snackbarcomp";

    export default {

        components: {
            snackbarcomp,
            resultDialog,
            kur,
            genelarama,
            genelaramakod,
            tarihcomp,
            geneltipara,
            parainput,
            yuzdeinput

        },
        watch: {


            tumunusec(valsec) {

                if (valsec == true) {
                    this.secilenkayitlar = this.val.Kisiler
                } else {
                    this.secilenkayitlar = []
                }
            }
        },

        props: ["value"],
        computed: {
            val: {
                get: function () {


                    return this.value;
                },
                set: function (newValue) {
                    this.$emit("input", newValue);
                }
            }
        },

        data() {
            return {
                text1: "",
                snackbar: false,
                vouchergoster: false,
                voucheritems: [],
                aractipitems: [],
                menu2: false,
                menu1: false,
                menualissati: false,
                menuteslimsati: false,
                menumusteslimsati: false,
                ucusnoitems: [],
                rehberdilitems: [],
                transfertipitems: [{
                        text: this.$t('None'),
                        value: "Yok"
                    },
                    {
                        text: this.$t('Golf-course-tasks'),
                        value: "Golf Sahası Yapacak"
                    },
                    {
                        text: this.$t('Agency-tasks'),
                        value: "Acenta Yapacak"
                    },
                ],

                vizetipitems: rez.VizeTipi(),
                vizedurumuitems: rez.VizeDurumu(),
                vizegiristipiitems: rez.VizeGirisTipi(),

                tumunusec: false,
                secilenkayitlar: [],
                dialogShow: false,
                error: "",
                adresler: [],
                search: "",
                selected: [],
                odemeTipi: rez.OdemeTipi,

                tabmodel: "tab-genel",

                kisiSira: [],
                headers: [{
                    text: "Isim",
                    align: "left",
                    value: "adSoyad",
                    sortable: false
                }],
                menuItems: [{
                        title: this.$t('Find-Price')
                    },
                    {
                        title: this.$t('Calculate-Price')
                    }
                ]
            };
        },

        created() {},
        methods: {
            FaturaGoster(val) {
            var url = '#/coper/page/formlar/fatura/id?islem=get&PNR_No=' + val
                window.open(url, '_blank')
            },
            voucherekran(val,rez) {
                var url = '#/coper/page/formlar/voucher/id?islem=get&Tip='+ rez.kalemler[0].saticiTip +'&PNR_No=' + val
                window.open(url, '_blank')
            },
            otelrezervasyonfisi(val) {
                var url = '#/coper/page/formlar/otelrezervasyonfisi/id?islem=get&PNR_No=' + val +'&rezType=1'
                window.open(url, '_blank')
            },
            kotasyonFormu(val){
                var url = '#/coper/page/formlar/kotasyonformu/id?islem=get&Tip=1&PNR_No=' + val
                window.open(url, '_blank')
            },
            gunhesapla(val) {

                const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
                const firstDate = new Date(val.donem1);
                const secondDate = new Date(val.donem2);

                const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));

                return diffDays

            },

            denemeyazdir(divName) {


                var mywindow = window.open('', 'PRINT', 'height=500,width=700');

                mywindow.document.write('</head><body >');
                mywindow.document.write(document.getElementById(divName).innerHTML);
                mywindow.document.write('</body></html>');

                mywindow.document.close(); // necessary for IE >= 10
                mywindow.focus(); // necessary for IE >= 10*/

                mywindow.print();
                mywindow.close();

                return true;


            },
            voucheryazdir() {

                var prm = {
                    printable: this.someJSONdata,
                    properties: ['name', 'email', 'phone'],
                    type: 'json'
                }

                //'printJS-form', 'html'
                printJS('printJS-form', 'html');



            },
            otelvoucherYazdir() {
                var params = {
                    PNR_No: this.val.Rez.pNR_No
                }
                tool.http_post(this, "OtelVoucher", params).then(
                    response => {

                        if (response.body.Status == true) {
                            this.voucheritems = response.body.data
                            this.vouchergoster = true
                        } else {

                            this.text1 = response.body.ErrorList[0]
                            this.snackbar = true
                            this.vouchergoster = false
                        }
                    },
                    response => {

                        this.text1 = this.$t('An-error-has-occurred-Please-try-again')
                        this.snackbar = true
                        this.vouchergoster = false

                    }
                );

            },
            kalemekle() {
                if(this.val.kalem.yet_KisiSayisi == ''){
                    this.snackbar = true;
                    this.text1 = this.$t('Number-of-Adults-cannot-be-empty');
                    return false;
                }

                if(this.val.kalem.satici.kod == null || this.val.kalem.satici.kod == ""){
                    let data ={
                    response: {},
                    request:{},
                    api:'kalemSaticiKontrol',
                    type:2,
                     message: this.$t('Vendor-cannot-be-empty-Please-add-Seller')
                    };
                    this.$refs.showMessage.open(data);
                    return false;
                }
                if(this.secilenkayitlar.length == 0 ){
                    this.text1 = this.$t('Contact-List-cannot-be-empty-Please-add-person');
                    this.snackbar = true;
                    return false;
                }
                if (this.val.kalem.P_RP == 'P') {

                } else {
                    // this.val.kalem.yet_Satis = 0;
                    this.val.kalem.co1_Satis = 0;
                    this.val.kalem.co2_Satis = 0;
                    this.val.kalem.co3_Satis = 0;
                    this.val.kalem.co4_Satis = 0;
                    this.val.kalem.ekY_Satis = 0;
                    //this.val.kalem.yet_KisiSayisi = this.secilenkayitlar.length
                    this.val.kalem.co1_KisiSayisi = 0;
                    this.val.kalem.co2_KisiSayisi = 0;
                    this.val.kalem.co3_KisiSayisi = 0;
                    this.val.kalem.co4_KisiSayisi = 0;
                    this.val.kalem.ekY_KisiSayisi = 0;
                }


                this.val.kalem.kalemOtel = null
                this.val.kalem.kalemArac = null
                this.val.kalem.kalemDiger = null
                this.val.kalem.kalemRentACar = null
                this.val.kalem.kisiSira = [];



                this.secilenkayitlar.forEach(element => {

                    var a = this.val.Kisiler.indexOf(element)

                    if (a != -1) {
                        this.val.kalem.kisiSira.push(a)
                    }

                });


                this.val.Rez.kalemler.push(this.val.kalem)
                this.val.islem = 'new'
                this.val.aktif = false
            },
            kalemguncelle() {
                if(this.val.kalem.yet_KisiSayisi == ''){
                    this.snackbar = true;
                    this.text1 = this.$t('Number-of-Adults-cannot-be-empty');
                    return false;
                }

                if(this.val.kalem.satici.kod == null || this.val.kalem.satici.kod == ""){
                    let data ={
                    response: {},
                    request:{},
                    api:'kalemSaticiKontrol',
                    type:2,
                     message: this.$t('Vendor-cannot-be-empty-Please-add-Seller')
                    };
                    this.$refs.showMessage.open(data);
                    return false;
                }


                if(this.secilenkayitlar.length == 0 ){
                    this.text1 = this.$t('Contact-List-cannot-be-empty-Please-add-person');
                    this.snackbar = true;
                    return false;
                }
                if (this.val.kalem.P_RP == 'P') {

                } else {
                    this.val.kalem.co1_Satis = 0;
                    this.val.kalem.co2_Satis = 0;
                    this.val.kalem.co3_Satis = 0;
                    this.val.kalem.co4_Satis = 0;
                    this.val.kalem.ekY_Satis = 0;

                    //this.val.kalem.yet_KisiSayisi = this.secilenkayitlar.length
                    this.val.kalem.co1_KisiSayisi = 0;
                    this.val.kalem.co2_KisiSayisi = 0;
                    this.val.kalem.co3_KisiSayisi = 0;
                    this.val.kalem.co4_KisiSayisi = 0;
                    this.val.kalem.ekY_KisiSayisi = 0;
                }

                this.val.kalem.kalemOtel = null
                this.val.kalem.kalemArac = null
                this.val.kalem.kalemDiger = null
                this.val.kalem.kalemRentACar = null

                this.val.kalem.kisiSira = [];


                this.secilenkayitlar.forEach(element => {

                    var a = this.val.Kisiler.indexOf(element)

                    if (a != -1) {
                        this.val.kalem.kisiSira.push(a)
                    }

                });

                this.val.Rez.kalemler.splice(this.val.recordno, 1, this.val.kalem)
                this.val.aktif = false
                this.val.islem = 'new'
            },

            KisiTipToStr(tip) {
                return rez.KisiTipToStr(tip);
            },
            SaticiTipToStr(tip) {
                return rez.SaticiTipToStr(tip);
            },
            setSelected(v) {
                this.selected = v;
            },
            setDialogShow(v) {
                this.dialogShow = v;
            },

            close() {
                this.value.dialogShow = false;
                setTimeout(() => {
                    this.value.kalem = Object.assign({}, rez.Kalem());

                    this.value.editedIndex = -1;
                }, 300);
            },

            modalOk() {
                this.value.kalem.kisiSira = [];
                for (var i = 0; i < this.selected.length; i++) {
                    this.value.kalem.kisiSira.push(this.selected[i].kisiSira);
                }

                if (this.value.editedIndex > -1) {
                    Object.assign(
                        this.value.Rez.kalemler[this.value.editedIndex],
                        this.value.kalem
                    );
                } else {
                    this.value.Rez.kalemler.push(this.value.kalem);
                }
                this.close();
            }
        },
        mounted() {
            this.val.kalem.masrafMerkezi = this.value.Rez.masrafMerkezi;
            this.secilenkayitlar = []
            for (var i = 0; i < this.value.kalem.kisiSira.length; i++) {
                this.secilenkayitlar.push(this.value.Rez.adresler[this.value.kalem.kisiSira[i]]);
            }

        },
    };
</script>
<style>

</style>